import { queryOptions, useMutation } from "@tanstack/react-query"

import { apiKey } from "@/lib/api/changes"
import { apiFetch } from "@/lib/api/client"
import type { ApiResource } from "@/lib/api/types"
import type { StaffTask } from "@/types/task"

export const taskQueries = {
  mine: () =>
    queryOptions({
      queryKey: apiKey("/me/tasks"),
      queryFn: async ({ signal }) => {
        const { data } = await apiFetch<ApiResource<StaffTask[]>>("/me/tasks", {
          signal,
        })

        return data
      },
    }),
}

export function useCloseTask() {
  return useMutation({
    mutationFn: async (taskId: string) => {
      const answer = await apiFetch<ApiResource<StaffTask> | undefined>(
        `/tasks/${taskId}`,
        { method: "PATCH", body: { status: "closed" } }
      )

      return answer?.data ?? null
    },
  })
}
